import { ALTERNATE_RX_PRODUCT_VALUE } from '../constants/product.constant';

export const hasAlternateRx = ({ products = [] }) => {
  let hasAlternateRx = false;
  for (let i = 0; i < products.length; i++) {
    const _product = products[i] || { ProductId: 0 };
    if (_product.ProductId === ALTERNATE_RX_PRODUCT_VALUE) {
      hasAlternateRx = true;
      break;
    }
  }
  return hasAlternateRx;
};

export const hasKit = ({ products = [] }) => {
  let hasKit = false;
  for (let i = 0; i < products.length; i++) {
    const _product = products[i] || { ProductName: '' };
    if (!_product?.ProductName?.length) {
      continue;
    }

    const regex = /(kit)/gmi;
    if (regex.test(_product.ProductName)) {
      hasKit = true;
      break;
    }
  }
  return hasKit;
};
